import {
  Box, Stack, FormControlLabel, Checkbox,
} from '@mui/material';
import styled from '@emotion/styled';
import { IoWarning } from 'react-icons/io5';
import { AIRCRAFT_SUBSCRIPTION_STATUS } from 'bluetail-globals';

import AdvancedOptionsCollapse from './AdvancedOptionsCollapse';
import { paletteColor } from 'common/theme/NutailTheme';

const getSubscriptionStatusName = (status) => {
  switch (status) {
    case AIRCRAFT_SUBSCRIPTION_STATUS.ACTIVE:
      return 'Active';
    case AIRCRAFT_SUBSCRIPTION_STATUS.PROVISIONAL:
      return 'Provisional';
    case AIRCRAFT_SUBSCRIPTION_STATUS.DEACTIVE:
      return 'Inactive';
    default:
      return 'Unknown';
  }
};

const YellowWarning = styled(Box)`
  background: ${paletteColor('activity_warning.light')};
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  font-size: 20px;
`;

const StyledWarningIcon = styled(IoWarning)`
  margin-right: 8px;
  color: ${paletteColor('activity_warning.main')};
  font-size: 42px;
`;

const WarningSubtitle = styled('span')`
  font-size: 14px;
  color: ${paletteColor('text.primary')};
  margin-top: 8px;
`;

const AircraftBox = styled(Box)`
  padding: 12px 0;
`;

function View({
  aircraftOrAssets,
  regNNumber,
  userOptInAddExisting,
  onUserOptInAddExisting,
}) {
  return aircraftOrAssets.length <= 0 || !regNNumber ? null : (
    <Box>
      <YellowWarning>
        <StyledWarningIcon />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>Aircraft already exists</span>
          <WarningSubtitle>
            {`This tail number (${regNNumber}) already exists under Customer(s): ${
              aircraftOrAssets.map((asset) => asset.account_name).join(', ')
            }`}
          </WarningSubtitle>
        </div>
      </YellowWarning>
      <Stack spacing={2}>
        {aircraftOrAssets
          .map((tail) => (
            <AircraftBox key={tail.account_name + tail.company_id}>
              <div>
                <strong>Customer:</strong>
                {' '}
                {tail.account_name}
              </div>
              <div>
                <strong>Status:</strong>
                {' '}
                {getSubscriptionStatusName(tail.recurly_status)}
              </div>
              {tail.deactivated_date && (
                <div>
                  <strong>Deactivated Date:</strong>
                  {' '}
                  {tail.deactivated_date}
                </div>
              )}
              {(tail.recurly_status === AIRCRAFT_SUBSCRIPTION_STATUS.DEACTIVE) && (
                <>
                  Transfer via
                  {' '}
                  <a href="/home/DeactivatedAircraft">Deactivated Aircraft</a>
                  {' '}
                  page
                </>
              )}
            </AircraftBox>
          ))}
      </Stack>
      <AdvancedOptionsCollapse>
        <FormControlLabel
          control={(
            <Checkbox
              checked={userOptInAddExisting}
              onChange={onUserOptInAddExisting}
            />
            )}
          label="I understand this tail number already exists, and I still want to create a new aircraft record."
        />
      </AdvancedOptionsCollapse>
    </Box>
  );
}

function Model({
  aircraftOrAssets = [], regNNumber, userOptInAddExisting, onUserOptInAddExisting,
}) {
  const hookProps = {
    aircraftOrAssets,
    regNNumber,
    userOptInAddExisting,
    onUserOptInAddExisting,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
